/* ── Retour ───────────────────────────────────────────────────────────
   Le cercle à bordure POINTILLÉE de la charte de référence : un rond vide,
   contour discontinu, flèche encre au centre. C'est le seul geste de retour
   de l'application — il ouvre chaque écran d'analyse, en haut à gauche.

   Le libellé est optionnel : posé à droite du cercle, en petites capitales
   lettrées, comme les intitulés de métrique de la charte. */

interface Props {
  onClick: () => void;
  /** Intitulé affiché à droite du cercle. Sans lui, seul le rond s'affiche. */
  label?: string;
  className?: string;
}

export default function BackButton({ onClick, label, className = '' }: Props) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={label ?? 'Retour'}
      className={`group mb-4 inline-flex items-center gap-3 ${className}`}
    >
      <span className="btn-back grid h-11 w-11 shrink-0 place-items-center rounded-full">
        <svg
          className="h-[18px] w-[18px]"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={1.6}
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M19 12H5" />
          <path d="M11 18l-6-6 6-6" />
        </svg>
      </span>
      {label && (
        <span className="text-[11px] font-semibold uppercase tracking-[0.14em] text-ink/60 transition-colors group-hover:text-ink">
          {label}
        </span>
      )}
    </button>
  );
}
